<template>
  <div id="app">
    <header id="header">
      <Menu/>
      <HeadFullView/>
      <Copy/>
    </header>
    <main>
      <MainFullView/>
      <Shop/>
      <Youtube/>
      <Plan/>
      <MapInfo/>
      <a href="https://nagasakigoto.net/products#am_soup" target="_blank" id="affterBox">
        <div class="aftterImageBox">
          <div class="images">
            <div>
              <img src="./assets/box.jpg" alt="">
            </div>
            <div>
              <img src="./assets/soup.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="affterContentBox">
          <img src="./assets/afterBtn@2x.png" alt="">
        </div>
      </a>
    </main>
    <Footer/>
  </div>
</template>

<script>
import HeadFullView from './components/HeadFullView.vue'
import Menu from './components/Menu.vue'
import Copy from './components/Copy.vue'
import MainFullView from './components/MainFullView.vue'
import Shop from './components/Shop.vue'
import Youtube from './components/Youtube.vue'
import Plan from './components/Plan.vue'
import MapInfo from './components/MapInfo.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    HeadFullView,
    Menu,
    Copy,
    MainFullView,
    Shop,
    Youtube,
    Plan,
    MapInfo,
    Footer
  },
}
</script>

<style lang="scss">
body, html{
  min-height: 100vh;
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", "メイリオ", sans-serif;
  font-weight: 500;
  color: #342b28;
}
#header{
  width: 100%;
}
.content{
  width: 1396px;
  margin: 0 auto;
}
.flex-container{
  display: flex;
  justify-content: space-between;
}
.flex-container.type2{
  flex-direction:row-reverse;
}
#affterBox{
  border: 1px solid #000;
  display: flex;
  padding: 10px 40px;
  height: 315px;
  max-width: 960px;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;
  color: #000;
  font-weight: bold;
  transition: border 200ms ease, margin-bottom 200ms ease;
}
.affterContentBox{
  flex-basis: 50%;
  padding-left: 50px;
  position: relative;
}
.aftterImageBox{
  flex-basis: 50%;
  position: relative;
}
.affterContentBox img{
  width: 380px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.aftterImageBox .images{
  display: flex;
  justify-content: space-around;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.aftterImageBox img{
  width: 200px;
}
.kochira{
  margin-top: 40px;
  font-size: 20px;
}
@media screen and (max-width:1396px){
  .content{
    width: 100%;
  }
}
@media screen and (max-width:930px){
  #affterBox{
    display: block;
    width: 542px;
    height: auto;
    padding: 30px;
  }
  .affterContentBox{
    margin: 0 auto;
    width:480px;
    padding-left: 0px;
  }
  .aftterImageBox{
    text-align: center;
    margin: 0 auto;
    width:480px;
    margin-bottom: 30px;
  }
  .affterContentBox img,
  .aftterImageBox .images{
    position: relative;
    transform: none;
  }
  .aftterImageBox .images{
    justify-content: space-between;
  }
}
@media screen and (max-width:650px){
  .commingsoon{
    padding-top: 20px;
  }
}
@media screen and (max-width:575px){
  #affterBox{
    display: block;
    width: 95%;
    font-size: 12px;
  }
  .affterContentBox{
    width:100%;
  }
  .kochira{
    font-size: 15px;
  }
  .aftterImageBox{
    width:100%;
  }
  .affterContentBox img{
    max-width: 100%;
  }
  .aftterImageBox img{
    max-width: 100%;
  }
}
</style>
